import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export interface ExcelHeader {
    header: string;
    field: string;
}

export async function generateExcelFile(fileName: string, data: any[], headers?: ExcelHeader[]) {
    try {
        let dataToExport = data;
        if (headers) {
            dataToExport = data.map((item) => {
                let newItem: any = {};
                headers.forEach((header) => {
                    newItem[header.header] = item[header.field];
                });
                return newItem;
            });
        }
        const ws = XLSX.utils.json_to_sheet(dataToExport);

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, fileName);

        // Write the file and trigger download
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const dataBlob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

        saveAs(dataBlob, `${fileName}.xlsx`);
    } catch (e) { }
}
